export default "__VITE_ASSET__50fe1843__"